/**
 * Het beeldmerk van PortefeuilleAtlas uit het ontwerp van 28-10-2026: een
 * kompasroos in een ronde atlasrand. Navy-wit met de oranje dwarsas; tekent in
 * `currentColor`, zodat hij op de navy zijbalk wit is en op het inlogscherm
 * net zo goed werkt.
 */
export function AtlasMark({ size = 34, className }: { size?: number; className?: string }) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 40 40" aria-hidden focusable="false">
      <circle cx="20" cy="20" r="18" fill="none" stroke="currentColor" strokeOpacity=".35" strokeWidth="1.5" />
      <path d="M20 4 L23.5 20 L20 36 L16.5 20Z" fill="currentColor" fillOpacity=".9" />
      <path d="M4 20 L20 16.5 L36 20 L20 23.5Z" fill="var(--atlas-color-nav-active-marker)" />
      <circle cx="20" cy="20" r="2.6" fill="var(--atlas-color-nav-bg)" stroke="currentColor" strokeWidth="1.2" />
    </svg>
  );
}
